import React from "react";
import styles from "./CoHost.module.scss";
import TextInput from "../TextInput";
import { Submit } from "../Submit";
import { LogoContainer } from "../LogoContainer";
import { ActionLink } from "../ActionLink";
import Gallery from "../../types/Gallery";
import useCoHosts from "../../hooks/useCoHosts";
import World from "../../world";
import { CoHost } from "../../api";
import CoHostList from "../CoHostList";

type Props = {
    world: World;
    gallery: Gallery;
    cohosts: Array<CoHost>;
}
export const AddCoHostForm = (props: Props) => {
    const {
        onChangeEmail,
        onSubmitAdd,
        onRemove,
        isPending,
        err,
        coHosts,
    } = useCoHosts(props.world, props.gallery, props.cohosts);

    return (
        <div className={styles["cohost-form"]}>
            <LogoContainer />

            <h1>Add a CoHost</h1>

            <p>CoHosts will have full control over this gallery</p>

            {err && (
                <p><span className="form-error">{err}</span></p>
            )}

            <form onSubmit={onSubmitAdd}>
                <TextInput
                    name="email"
                    placeholder="somebody@gmail.com"
                    help="Email of someone you trust to manage your gallery"
                    required
                    nocomplete
                    onChange={onChangeEmail} />

                <Submit label="Add" is_pending={isPending} />

                <ActionLink to={`/dashboard/galleries/${props.gallery.id()}`}>
                    cancel
                </ActionLink>
            </form>

            <CoHostList onRemove={onRemove} cohosts={coHosts} />
            
            <div className={styles["return-home-link"]}>
                <ActionLink to={`/dashboard/galleries/${props.gallery.id()}`}>
                        return to gallery home
                </ActionLink>   
            </div>
        </div>
    );
};

export default AddCoHostForm;
